import BeaconAction from '@tencent/beacon-web-sdk';
import { config } from '@/scripts/tools/config';

// eslint-disable-next-line import/no-mutable-exports
let reporter = {
  report() {},
};

const isDev = process.env.NODE_ENV === 'development';
// dev模式不上报
if (!isDev) {
  reporter = new BeaconAction({
    appkey: '0WEB0VOYMB4T2OLY', // 系统或项目id, 必填
    versionCode: config.version, // 项目版本,选填
    channelID: '', // 渠道,pc端上送为操作系统类型
    openid: '', // 用户id, 选填
    unionid: '', // 用户unionid , 类似idfv,选填
    strictMode: false, // 严苛模式开关, 打开严苛模式会主动抛出异常, 上线请务必关闭!!!
    delay: 1000, // 普通事件延迟上报时间(单位毫秒), 默认1000(1秒),选填
    sessionDuration: 60 * 1000,
  });

  reporter.report = (eventCode, params) => {
    // 使用灯塔实时上报
    reporter.onDirectUserAction(eventCode, params);
  };
}

export default reporter;
